import { Badge } from './styled'

export const BadgeMessage = ({ number }) => {
  return <Badge>{number}</Badge>
}
